<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb 
          parentRouteName="TagList" 
          :extra-items="[
            {
              text: tagName,
              to: 'TagView',
              params: $route.params.tag_id
            },
            '會員列表'
          ]" 
        />
      </div>
    </div>
    <b-overlay :show="isFetching">
      <b-card>
        <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
          <h4 class="mb-2 mb-xl-0 mr-2 ml-3 font-weight-bold">{{tagName}}的會員列表</h4>
          <div
            class="
              col-12 col-xl-6
              d-flex
              flex-column flex-xl-row
              align-items-start align-items-xl-center
            "
          >
            <b-dropdown
              class="flex-shrink-0  mr-3"
              variant="inverse-info"
            >
              <template #button-content>
                <span class="mdi mdi-download"></span> 資料匯出
              </template>
              <b-dropdown-item @click="exportCustomers('excel')">下載 EXCEL</b-dropdown-item>
              <b-dropdown-item @click="exportCustomers('csv')">下載 CSV</b-dropdown-item>
            </b-dropdown>
            <b-input-group class="mb-2">
              <b-form-input v-model="query.keyword" placeholder="搜尋" @keyup.enter="handlePageReset"></b-form-input>
              <b-input-group-append>
                <b-button @click="handlePageReset"><i class="fa fa-search"></i></b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>


        <div class="row">
          <div class="col-12">
            <b-table
              striped
              hover
              responsive
              :items="customers"
              :fields="fields"
            >
              <template #cell(avatar_url)="data">
                <div class="d-flex align-items-center justify-content-center">
                  <router-link :to="{ name: 'CustomerDetailView', params: { customerID: data.item.id } }" >
                    <b-avatar
                      :src="data.item.avatar_url"
                      variant="secondary"
                      size="2rem"
                    ></b-avatar>
                  </router-link>
                </div>
              </template>
              <template #cell(name)="data">
                <router-link :to="{ name: 'CustomerDetailView', params: { customerID: data.item.id } }" >
                  {{ data.item.name }}
                </router-link>
              </template>
              <template #cell(action)="data">
                <div class="d-flex justify-content-center">
                  <b-button variant="inverse-danger" size="sm" @click="unbindCustomer(data.item)">
                    移除會員
                  </b-button>
                </div>
              </template>
            </b-table>
          </div>
        </div>

        <CustomPagination
          :currentPage="query.page"
          :totalRows="totalRows"
          :perPage="query.per_page"
          @page-change="handlePageChange"
          @per-page-change="handlePerPageChange"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { zh } from "vuejs-datepicker/dist/locale";
import { BAvatar } from "bootstrap-vue";

import "bootstrap-vue/dist/bootstrap-vue.css";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { paginationMixin } from "@/mixins/pagination";
import { updateQueryFromRoute, updateUrl } from "@/utils/updateUrl";
import {mapGetters, mapState} from "vuex";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import deepGet from "@/utils/deepGet";
import tagApi from "@/apis/tag";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    CustomPagination,
    BAvatar,
    BreadCrumb,
  },
  mixins: [paginationMixin],
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      startAt: {
        date: {
          required
        },
        time: {
          HH: { required },
          mm: { required },
        },
      },
      endAt: {
        date: { required },
        time: {
          HH: { required },
          mm: { required },
        },
      },
    };
  },
  data() {
    return {
      zh,
      totalRows: 0,
      isFetching: false,
      customerLevel: {
        name: "",
      },
      showLoadingUpload: false,
      batchAssignFile: null,
      batchAssignStep: 1,
      importCustomerPreview: {
        total_member_count: 0,
        valid_member_count: 0,
      },
      customers: [],
      baseFields: [
        { key: "avatar_url", label: "" },
        { key: "name", label: "LINE 名稱" },
        { key: "tags_count", label: "數量" },
      ],
      fields: [],
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
        keyword: ""
      },
      customerMerchantType: "line",
      customerTimeTitle: null,
      startAt: {
        date: null,
        time: {
          HH: null,
          mm: null,
        },
      },
      endAt: {
        date: null,
        time: {
          HH: null,
          mm: null,
        },
      },
      isSubmit: false,
      tagId: null,
      tagName: null,
    };
  },

  created() {
    this.query = updateQueryFromRoute(
      this.$route,
      this.$store,
      this.query
    );
  },

  mounted() {
    this.tagId = this.$route.params.tag_id;
    this.isFetching = true;
    this.fetchTag();
    this.fetchCustomers();

    this.fields = this.baseFields
                      .concat(this.getModule("customer") ? [] : this.getDefaultCustomerFields())
                      .concat(this.normalizeProfileFields())
                      .concat({ key: "action", label: "操作" });

    this.initialized = true;
  },

  computed: {
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
      getModule: "dashboardModule/getModule",
    }),
    ...mapState("general", {
      defaultMerchantType: (state) => state.defaultMerchantType,
      organization: (state) => state.organization,
    }),
  },

  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrl(this.query, this.$store, this.$router);
      },
    },
    $route(to) {
      if (!this.initialized) return;
      this.query = { ...to.query };
      this.fetchCustomers();
    },
  },

  methods: {
    deepGet,
    async fetchTag() {
      const response = await tagApi.getTag(
        this.organization,
        this.$route.params.tag_id
      );
      this.tagName = response.data.data.name ?? '';
    },
    async fetchCustomers() {
      try {
        this.isFetching = true;
        const { data } = await tagApi.getCustomers(
          this.tagId,
          { ...this.query }
        );
        this.customers = data.data;
        this.totalRows = data.meta.total;
      } catch (e) {
        console.log(e)
      }
      this.isFetching = false
    },
    async exportCustomers(type) {
      try {
        this.isFetching = true;
        let params = { type: type === 'csv' ? 'csv' : 'excel' };
        await tagApi.exportCustomers(this.tagId, params).then(() => {
          this.$swal({
            title: '成功',
            text: "可至“我的主控台”查看紀錄及下載檔案",
            showCancelButton: true,
            cancelButtonText: '確認',
            type: 'success',
            confirmButtonText: '前往查看',
          }).then((result)=>{
              if (result.value) {
                this.$router.push({
                  name: "MyConsoleDownloadFileList",
                  params: { org_code: this.$route.params.org_code },
                });
              }
            });
        });
      } catch (e) {
        console.log(e)
      }
      this.isFetching = false
    },
    async unbindCustomer(customer) {
      const result = await this.$swal({
        title: "移除會員",
        text: `確定要將 ${customer.name} 移除嗎?`,
        type: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "移除",
        reverseButtons: true,
      })
      if (! result.value) {
        return
      }

      this.isFetching = true
      try {
        await tagApi.unbindCustomer(this.tagId, { customer_id: customer.id })
        await this.fetchCustomers()
      } catch (error) {
        console.error(error);

        this.$swal(
          "解除失敗",
          `${customer.name} 解除失敗`,
          "warning"
        );
      }
      this.isFetching = false
    },
    normalizeProfileFields() {
      const customerList = this.getModuleConfig("customer", "member.customer_list");

      const profileMappings =
        customerList?.find(
          (list) => list.merchant_type.toUpperCase() == this.defaultMerchantType
        )?.member_fields ?? [];

      if (profileMappings) {
        return profileMappings.map((mapping) => {
          if (mapping.matched_key.startsWith("extra.")) {
            const key = mapping.matched_key.split("extra.")[1];
            return {
              key: `profiles.${key}`,
              label: mapping.title,
            };
          } else {
            return {
              key: mapping.matched_key,
              label: mapping.title,
            };
          }
        });
      } else {
        return [];
      }
    },
    getDefaultCustomerFields() {
      return [
        { key: "outer_code", label: "識別編號" },
        { key: "mobile_phone", label: "手機" },
        { key: "email", label: "Email" },
      ];
    },
  },
};
</script>

<style scoped>
  /* 讓內部 <input> 的樣式隨驗證狀態改變 */
  .vue__time-picker input.is-invalid {
    border-color: red !important;
  }
</style>
